import WebFontLoader from 'webfontloader'

// async load fonts
WebFontLoader.load({
  google: {
    families: ['Tajawal:ital,wght@0,400;0,500;0,600;0,700;1,400&display=swap'],
  },
})
